/**
 * Утиліти для роботи з типами бізнесу
 * @utils businessUtils
 * @file businessUtils.ts
 * @path frontend/src/utils/businessUtils.ts
 */

/**
 * Типи бізнесу в системі
 */
export enum BusinessTypes {
  SALON = 'salon',
  TIRE_STATION = 'tire_station',
  AUTO_SERVICE = 'auto_service',
  SPA = 'spa',
}

export type BusinessType = BusinessTypes;

// ... (решта коду залишається без змін)
